import { FC } from 'react';
import { UserTable } from '../components/userTable.component';
import { PageHeader } from '#dashboard/components/pageHeader.component';
import { useAppContext } from '#hooks';
import { CustomStatsButton } from '#esims/components/customStatsButton.component';
import { Database } from '#types';
import { AllowListDropDown } from '#users/components/allowListDropDown.component';
import { DownloadUsersButtons } from '#users/components/downloadUsersButtons.component';

export const CurrentUsers: FC = () => {

    const { loggedInUser, currentDb } = useAppContext();

    return <>
        <PageHeader header={'Current Users'} />
        <UserTable />
        {
            loggedInUser?.roles?.SUPERUSER && currentDb === Database.ZIM && <CustomStatsButton />
        }
        {
            loggedInUser?.roles?.SUPERUSER && <DownloadUsersButtons />
        }
        {
            (loggedInUser?.roles?.SUPERUSER || loggedInUser?.roles?.AFFILIATE) && currentDb === Database.GD && <AllowListDropDown />
        }
    </>
}
